module.exports = __webpack_public_path__ + "static/media/USDT-logo.6e4a4358.png";